module.exports = __webpack_public_path__ + "img/cresc_1.1547b283.png";